import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import { RemoveItemButton } from '~pages/Sales/sharedSales/RemoveItemButton';

interface FormArrayRowCardProps {
  children: React.ReactNode;
  dataTestId?: string;
  // Omit to render the card with no remove control, for a row the user cannot
  // delete (e.g. an order's own scalar material).
  onRemove?: () => void;
  removeIconDataTestId?: string;
  spacing?: number;
}

// Card chrome for one row of a repeatable form array: a panel with a colored
// left accent whose remove control floats over the top-right corner. Consumers
// pass the row's own `<Grid size>` fields as children.
const FormArrayRowCard = ({
  children,
  dataTestId,
  onRemove,
  removeIconDataTestId,
  spacing = 2,
}: FormArrayRowCardProps) => {
  const theme = useTheme();

  return (
    <Grid
      container
      spacing={spacing}
      data-test-id={dataTestId}
      sx={{
        bgcolor: 'background.paper',
        border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        borderRadius: 2,
        mb: 0,
        mt: 2,
        mx: 0,
        pb: 1,
        pl: spacing,
        position: 'relative',
        pr: 2,
        pt: spacing,
        width: '100%',
      }}
    >
      {children}

      {onRemove === undefined ? null : (
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            transform: 'translate(50%, -50%)',
          }}
        >
          <RemoveItemButton
            action={onRemove}
            iconDataTestId={removeIconDataTestId}
            sx={{ cursor: 'pointer' }}
          />
        </Box>
      )}
    </Grid>
  );
};

export { FormArrayRowCard };
